import { render, staticRenderFns } from "./HighlightLenders.vue?vue&type=template&id=f6ed79f4&scoped=true&"
import script from "./HighlightLenders.vue?vue&type=script&lang=js&"
export * from "./HighlightLenders.vue?vue&type=script&lang=js&"
import style0 from "./HighlightLenders.vue?vue&type=style&index=0&id=f6ed79f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ed79f4",
  null
  
)

export default component.exports